export const JOURNEY_SET_ERROR = 'JOURNEY_SET_ERROR';
export const JOURNEY_RESET = 'JOURNEY_RESET';
export const JOURNEY_SET_LOADING = 'JOURNEY_SET_LOADING';
export const JOURNEY_SET_ITEMS = 'JOURNEY_SET_ITEMS';
export const JOURNEY_SET_POSITION = 'JOURNEY_SET_POSITION';
export const JOURNEY_SET_BUTTON_VOLUME = 'JOURNEY_SET_BUTTON_VOLUME';
export const JOURNEY_SET_MUSIC_VOLUME = 'JOURNEY_SET_MUSIC_VOLUME';
export const JOURNEY_SET_TRACK = 'JOURNEY_SET_TRACK';
export const JOURNEY_SET_PENDING_TRAINER_WIN = 'JOURNEY_SET_PENDING_TRAINER_WIN';
